import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { waitBeforeRequests } from './api/client';
import { queryClient } from './api/queries';
import { App, preloadMap } from './App';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';

// Tant que le vrai serveur n'existe pas, l'API simulée répond dans la page (voir src/mocks/network.ts).
if (!import.meta.env.VITE_API_URL) {
  waitBeforeRequests(import('./mocks/network').then((m) => m.startMockApi()));
}

if (import.meta.env.PROD) {
  void import('virtual:pwa-register').then(({ registerSW }) => registerSW({ immediate: true }));
}

const container = document.getElementById('root')!;
const app = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
// En production la coque est prérendue (scripts/prerender.mjs) : React la reprend sans la redessiner.
if (container.hasChildNodes()) hydrateRoot(container, app);
else createRoot(container).render(app);
preloadMap();

// Carte du jour hors ligne : le cache des réponses est rechargé depuis le téléphone puis tenu à jour.
// Branché après le premier affichage ; hors ligne, les requêtes attendent et reçoivent ces copies.
void import('./api/persist').then(({ startPersistence }) => startPersistence(queryClient));
